import {
  Box,
  Button,
  Flex,
  HStack,
  Heading,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Spacer,
  Spinner,
  Stack,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FcPlus } from "react-icons/fc";
import {
  addDocumentFirebase,
  deleteDocumentFirebase,
  getCollectionFirebase,
  getSingleDocumentFirebase,
} from "../../Apis/firebaseApi";
import {
  TiEdit,
  TiFeather,
  TiHeadphones,
  TiMessageTyping,
  TiMessages,
  TiNews,
  TiPuzzleOutline,
  TiSortAlphabeticallyOutline,
  TiStarFullOutline,
  TiThumbsOk,
  TiTrash,
  TiWaves,
} from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { UseAuthStore } from "../../Hooks/Zustand/store";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../Config/firebase";
import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import moment from "moment";

const TemplateTextPage = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState();
  const [data, setData] = useState();
  const [title, setTitle] = useState("");
  const [modalNewPage, setModalNewPage] = useState(false);
  const [inputSearchTemplate, setInputSearchTemplate] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const globalState = UseAuthStore();
  const [dataTemplate, setDataTemplate] = useState();
  const toast = useToast();
  const deleteModal = useDisclosure();

  const handleNewPage = async () => {
    if (!globalState?.currentCompany) {
      return toast({
        title: "Error",
        description: "Please check your select company",
        status: "error",
      });
    }
    if (!globalState?.currentProject) {
      return toast({
        title: "Error",
        description: "Please check your select project",
        status: "error",
      });
    }

    const dataPage = {
      title: title,
      type: "website",
      projectId: globalState?.currentProject,
    };

    const collectionName = "templates";

    try {
      const docID = await addDocumentFirebase(
        collectionName,
        dataPage,
        globalState.currentCompany
      );

      const resultUpdate = await addDocumentFirebase(
        "logs",
        {
          activity: `add funnel ai landing page`,
          uid: globalState.uid,
          projectId: globalState.currentProject,
          details: {
            dataPage,
            id: docID,
          },
        },
        globalState.currentCompany
      );
      console.log(resultUpdate, "logs updated");
      setModalNewPage(false);
    } catch (error) {
      console.log("Terjadi kesalahan:", error);
    }
  };

  const getTemplateData = async () => {
    try {
      const res = await getCollectionFirebase(`templates`);
      setData(res);
    } catch (error) {
      console.log(error, "ini error");
    }
  };

  const searchWebTemplate = (text) => {
    console.log(text);
    if (text) {
      const newData = templates?.filter((item) => {
        const itemData = item.title
          ? item.title.toUpperCase()
          : "".toUpperCase();
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      setSearchedData(newData);
      setInputSearchTemplate(text);
    } else {
      setSearchedData(templates);
      setInputSearchTemplate(text);
      console.log(searchedData);
    }
  };

  const getuserTemplates = async () => {
    const q = query(
      collection(db, "templates"),
      // where("createdBy", "==", globalState.uid),
      where("type", "==", "website")
      // where("companyId", "==", globalState.currentCompany)
    );
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const templateArr = [];
      querySnapshot.forEach((doc) => {
        templateArr.push({ ...doc.data(), id: doc.id });
      });

      setTemplates(templateArr);
    });
  };

  const handleOpenModal = (template) => {
    deleteModal.onOpen();
    setDataTemplate(template);
  };

  const handleDeleteTemplate = async () => {
    try {
      const result = await deleteDocumentFirebase(
        "templates",
        dataTemplate?.id
      );

      toast({
        status: "success",
        title: "Deoapp AI",
        description: "Template Deleted",
        duration: 1000,
      });

      deleteModal.onClose();
    } catch (error) {
      console.log("Terjadi kesalahan:", error);
    }
  };

  const inputStyles = {
    "&::placeholder": {
      color: "gray.500",
    },
  };

  useEffect(() => {
    getuserTemplates();
  }, []);

  return (
    <Box>
      <HStack my={5}>
        <Heading>Web Templates Collection</Heading>
        <Spacer />
        <Button
          colorScheme="green"
          variant="outline"
          onClick={() => setModalNewPage(true)}
          // onClick={handleNewTemplate}
        >
          <HStack spacing={2}>
            <FcPlus />
            <Text textTransform="uppercase" fontSize="sm" fontWeight={500}>
              New Folder
            </Text>
          </HStack>
        </Button>
      </HStack>

      <Input
        type="text"
        placeholder="Search Files ..."
        bgColor="white"
        color="black"
        sx={inputStyles}
        fontSize="sm"
        onChange={(e) => searchWebTemplate(e.target.value)}
      />

      {templates?.length === 0 && searchedData?.length === 0 ? (
        <Spinner />
      ) : (
        <SimpleGrid columns={4} spacing={4} my={8}>
          {inputSearchTemplate === "" ? (
            <>
              {templates?.map((x, i) => {
                return (
                  <Stack
                    _hover={{
                      transform: "scale(1.03)",
                      shadow: "xl",
                    }}
                    transition={"0.2s ease-in-out"}
                    spacing={2}
                    borderTopWidth={3}
                    borderColor="green.500"
                    alignItems="center"
                    justifyContent="start"
                    bgColor="#2B2B2B"
                    key={i}
                    py={4}
                    px={2}
                    borderRadius="md"
                    shadow="md"
                    // Tambahkan properti disabled jika id kosong
                    disabled={!x.id}
                    opacity={!x.id ? 0.5 : 1}
                    cursor={!x.id ? "not-allowed" : "pointer"}
                  >
                    <Stack
                      p={5}
                      onClick={() => {
                        if (x.id) {
                          navigate(`/lptrain/${x.id}`);
                        }
                      }}
                    >
                      <Icon
                        as={TiFeather}
                        color={x.iconColor}
                        boxSize={12}
                        alignSelf="center"
                      />
                    </Stack>
                    <Box align={"center"}>
                      <Text fontWeight="bold" textTransform={"capitalize"}>
                        {x?.title}
                      </Text>
                      {/* <Text fontSize={12}>Category: {x.section}</Text> */}
                    </Box>
                    <HStack fontSize={"md"}>
                      <Text fontSize="2xs">
                        {moment
                          .unix(
                            x?.lastUpdated?.seconds ?? x?.createdAt?.seconds
                          )
                          .fromNow()}
                      </Text>
                      <Spacer />
                      <Icon as={TiTrash} onClick={() => handleOpenModal(x)} />
                    </HStack>
                  </Stack>
                );
              })}
            </>
          ) : (
            <>
              {searchedData?.map((x, i) => {
                return (
                  <Stack
                    _hover={{
                      transform: "scale(1.03)",
                      shadow: "xl",
                    }}
                    transition={"0.2s ease-in-out"}
                    spacing={2}
                    borderTopWidth={3}
                    borderColor="green.500"
                    alignItems="center"
                    justifyContent="start"
                    bgColor="#2B2B2B"
                    key={i}
                    py={4}
                    px={2}
                    borderRadius="md"
                    shadow="md"
                    // Tambahkan properti disabled jika id kosong
                    disabled={!x.id}
                    opacity={!x.id ? 0.5 : 1}
                    cursor={!x.id ? "not-allowed" : "pointer"}
                  >
                    <Stack
                      p={5}
                      onClick={() => {
                        if (x.id) {
                          navigate(`/lptrain/${x.id}`);
                        }
                      }}
                    >
                      <Icon
                        as={TiFeather}
                        color={x.iconColor}
                        boxSize={12}
                        alignSelf="center"
                      />
                    </Stack>
                    <Box align={"center"}>
                      <Text fontWeight="bold" textTransform={"capitalize"}>
                        {x?.title}
                      </Text>
                      {/* <Text fontSize={12}>Category: {x.section}</Text> */}
                    </Box>
                    <HStack fontSize={"md"}>
                      <Text fontSize="2xs">
                        {moment
                          .unix(
                            x?.lastUpdated?.seconds ?? x?.createdAt?.seconds
                          )
                          .fromNow()}
                      </Text>
                      <Spacer />
                      <Icon as={TiTrash} onClick={() => handleOpenModal(x)} />
                    </HStack>
                  </Stack>
                );
              })}
            </>
          )}
        </SimpleGrid>
      )}

      <Modal
        isOpen={modalNewPage}
        onClose={() => setModalNewPage(false)}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Folder</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              type="text"
              placeholder="Folder Name"
              onChange={(e) => setTitle(e.target.value)}
            />
          </ModalBody>

          <ModalFooter>
            <Flex gap={5}>
              <Button
                leftIcon={<AddIcon boxSize={3} />}
                colorScheme="green"
                onClick={() => handleNewPage()}
              >
                Add New
              </Button>
              <Button
                leftIcon={<CloseIcon boxSize={3} />}
                colorScheme="red"
                onClick={() => {
                  setModalNewPage(false);
                }}
              >
                Cancel
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={deleteModal.isOpen} onClose={deleteModal.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{dataTemplate?.title} Template</ModalHeader>
          <ModalBody>Template will be deleted, are you sure?</ModalBody>
          <ModalFooter>
            <HStack>
              <Button
                size={"sm"}
                colorScheme="green"
                onClick={handleDeleteTemplate}
              >
                Yes
              </Button>
              <Button
                size={"sm"}
                colorScheme="red"
                onClick={deleteModal.onClose}
              >
                No
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TemplateTextPage;
